/* eslint-disable jsx-a11y/click-events-have-key-events -- TODO */
import type { CSSProperties, ReactNode } from "react";

import { cn } from "../../../utils";
import type { TableProps, TableRowType } from "../Table.types";

export interface TableRowProps<
  Row extends TableRowType,
  Group extends string = never,
> extends Pick<
  TableProps<Row, Group>,
  "activeRowIds" | "renderRowEffect" | "renderRowExpansion" | "onRowClick"
> {
  row: Row;
  rowId: string;
  isOpen: boolean;
  isActive: boolean;
  rowIndex: number;
  children: ReactNode;
  className?: string;
  virtualStyle?: CSSProperties;
  gridColumnRules: string[];
}

export const TableRow = <
  Row extends TableRowType,
  Group extends string = never,
>({
  row,
  rowId,
  isOpen,
  isActive,
  rowIndex,
  children,
  className,
  virtualStyle,
  gridColumnRules,
  onRowClick,
  renderRowEffect,
  renderRowExpansion,
}: TableRowProps<Row, Group>) => {
  return (
    <>
      <div
        role="button"
        tabIndex={-1}
        style={{
          gridTemplateColumns: gridColumnRules.join(" "),
          ...virtualStyle,
        }}
        className={cn(
          "ui:relative ui:grid ui:border-t ui:border-divider",
          className,
        )}
        onClick={() =>
          onRowClick?.({
            row,
            rowId,
            rowIndex,
          })
        }
      >
        {renderRowEffect?.({
          row,
          rowIndex,
          isActive,
        }) ?? null}

        {children}
      </div>

      {renderRowExpansion?.({
        row,
        rowIndex,
        isOpen,
      }) ?? null}
    </>
  );
};
